/**
 * Created by Ning Jiang on 9/22/2016.
 */
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TweenLite, Power3, Linear} from "gsap";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";


export class GameDimOverLay extends PIXI.Container {

    private _dimOverLay: PIXI.Graphics;
    private _dimOverLayTween: TweenLite;

    constructor() {
        super();
        this.initAnimation();
    }

    public onDimStage(): void {
        if (this._dimOverLayTween && this._dimOverLayTween.isActive()) {
            this._dimOverLayTween.kill();
        }
        this.name = "dimmer";
        this._dimOverLayTween = TweenLite.to(this._dimOverLay, 0.1, {
            alpha: 0.4,
            ease: Power3.easeIn
        });
    }

    public onResize(): void {
        this._dimOverLay.clear();
        this._dimOverLay.beginFill(0x000000, 1);
        this._dimOverLay.drawRect(360, 360,
            NolimitApplication.screenBounds.width,
            NolimitApplication.screenBounds.height);
        this._dimOverLay.endFill();
        this.pivot.set(this._dimOverLay.width * 0.5, this._dimOverLay.height * 0.5);
    }

    public onUndimStage(duration: number): void {
        if (this._dimOverLayTween && this._dimOverLayTween.isActive()) {
            this._dimOverLayTween.kill();
        }
        this._dimOverLayTween = TweenLite.to(this._dimOverLay, duration, {
            alpha: 0,
            onComplete: () => this.onUndimStageComplete()
        });
    }

    private initAnimation(): void {
        this._dimOverLay = new PIXI.Graphics();
        this._dimOverLay.beginFill(0x000000, 1);
        this._dimOverLay.drawRect(360, 360,
            NolimitApplication.screenBounds.width,
            NolimitApplication.screenBounds.height);
        this._dimOverLay.endFill();
        this._dimOverLay.alpha = 0;
        this.pivot.set(this._dimOverLay.width * 0.5, this._dimOverLay.height * 0.5);
        this.addChild(this._dimOverLay);
        OktoberfestLayers.getLayer(Layers.DIM_STAGE)!.addChild(this);
    }

    private onUndimStageComplete(): void {

    }
}
